import { API } from '@skeepers/platform-framework';

import ENSURE_APPLICATION from './ensureApplication.gql';
import UPDATE_PROGRESS from './updateProgress.gql';
import LINK_PROJECT from './linkProject.gql';

export class CastingAPI extends API {
    async ensureApplication (solutionId, userId) {
        const { data } = await this.client.mutate({
            mutation: ENSURE_APPLICATION,
            variables: {
                input: {
                    solutionId,
                    userId,
                },
            },
        });

        return data.ensureApplication.application;
    }

    async updateProgress (applicationId, progress) {
        const { data } = await this.client.mutate({
            mutation: UPDATE_PROGRESS,
            variables: {
                input: {
                    applicationId,
                    progress,
                },
            },
        });

        return data.updateApplicationProgress.application;
    }

    async linkProject (applicationId, project) {
        const { data } = await this.client.mutate({
            mutation: LINK_PROJECT,
            variables: {
                input: {
                    applicationId,
                    projectId: project.id,
                },
            },
        });

        return data.linkProjectToApplication.isProjectLinked;
    }
}
